import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { useAuth } from '@/contexts/auth-context';
import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { Link2, LogOut, User } from 'lucide-react';

export function AppHeader() {
  const { user, logout } = useAuth();
  const { data: health } = useQuery({
    queryKey: ['app-health'],
    queryFn: () => api.get<{ appEnv: string }>('/health'),
    staleTime: Infinity,
    retry: false,
  });
  const isStaging = health?.appEnv === 'staging';

  return (
    <header
      className={`flex h-14 items-center gap-4 border-b px-6 ${
        isStaging ? 'border-amber-400 bg-amber-100 text-amber-950' : 'bg-background'
      }`}
    >
      <SidebarTrigger />
      <div className="flex-1" />
      <div className="flex items-center gap-4">
        {isStaging && (
          <Badge variant="warning" className="border border-amber-600 bg-amber-500 text-amber-950">
            STAGING
          </Badge>
        )}
        <span className="text-sm text-muted-foreground">FAME Travel Designers</span>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-8 w-8 rounded-full">
              <User className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium">{user?.fullName || user?.email}</p>
                {user?.fullName && <p className="text-xs text-muted-foreground">{user.email}</p>}
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => (window.location.href = '/api/exact/auth/start')}
              className="cursor-pointer"
            >
              <Link2 className="mr-2 h-4 w-4" />
              <span>Exact Online Koppelen</span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout} className="cursor-pointer">
              <LogOut className="mr-2 h-4 w-4" />
              <span>Afmelden</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
